import React from 'react';
import { usePageMotion } from '../hooks/usePageMotion';
import './Services.css';

interface Service {
  icon: string;
  title: string;
  description: string;
  features: string[];
}

const Services: React.FC = () => {
  const root = usePageMotion<HTMLDivElement>();
  const services: Service[] = [
    {
      icon: 'fas fa-code',
      title: 'Desenvolvimento Web',
      description: 'Sistemas e interfaces para o trabalho do dia a dia',
      features: [
        'Sites institucionais',
        'Sistemas web completos',
        'APIs RESTful',
        'Progressive Web Apps'
      ]
    },
    {
      icon: 'fab fa-python',
      title: 'Desenvolvimento Python',
      description: 'Scripts e aplicações para trabalhar com dados e automatizar tarefas',
      features: [
        'Automação de processos',
        'Scripts personalizados',
        'Integração de sistemas',
        'Tratamento de dados'
      ]
    },
    {
      icon: 'fas fa-database',
      title: 'Banco de Dados',
      description: 'Modelagem e otimização de bancos de dados',
      features: [
        'Modelagem de tabelas',
        'Otimização de consultas',
        'Migração de dados',
        'Backup e recuperação'
      ]
    },
    {
      icon: 'fas fa-robot',
      title: 'Automação',
      description: 'Menos tempo gasto repetindo a mesma tarefa',
      features: [
        'Web scraping',
        'Automação de tarefas',
        'Bots e scripts',
        'Integração de APIs'
      ]
    },
    {
      icon: 'fas fa-mobile-alt',
      title: 'Aplicações Responsivas',
      description: 'Interfaces adaptadas para celular, tablet e computador',
      features: [
        'Design responsivo',
        'Mobile-first',
        'Cross-browser',
        'Performance otimizada'
      ]
    },
    {
      icon: 'fas fa-cog',
      title: 'Consultoria Técnica',
      description: 'Uma segunda visão sobre o código e as decisões do projeto',
      features: [
        'Arquitetura de software',
        'Code review',
        'Otimização de código',
        'Boas práticas'
      ]
    }
  ];

  return (
    <div className="services-page" ref={root}>
      <section className="services-hero">
        <div className="container" data-hero-reveal>
          <span className="eyebrow">DESENVOLVIMENTO / SERVIÇOS</span>
          <h1 className="page-title">O que posso construir com você</h1>
          <p className="page-subtitle">
            Um sistema novo, uma integração ou uma tarefa que precisa parar de ser manual. Podemos começar por aí.
          </p>
        </div>
      </section>

      <section className="services-content">
        <div className="container">
          <div className="services-grid">
            {services.map((service, index) => (
              <div key={index} className="service-card" data-reveal>
                <div className="service-icon">
                  <i className={service.icon}></i>
                </div>
                <h3 className="service-title">{service.title}</h3>
                <p className="service-description">{service.description}</p>
                <ul className="service-features">
                  {service.features.map((feature, idx) => (
                    <li key={idx}>
                      <i className="fas fa-check"></i>
                      <span>{feature}</span>
                    </li>
                  ))}
                </ul>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="process-section">
        <div className="container">
          <h2 className="section-title" data-reveal>Como o projeto acontece</h2>
          <div className="process-grid">
            <div className="process-step" data-reveal>
              <div className="step-number">1</div>
              <h3>Análise</h3>
              <p>Conversamos sobre a rotina e escolhemos o problema que vamos resolver.</p>
            </div>
            <div className="process-step" data-reveal>
              <div className="step-number">2</div>
              <h3>Planejamento</h3>
              <p>Combinamos as entregas, as tecnologias e os prazos de cada etapa.</p>
            </div>
            <div className="process-step" data-reveal>
              <div className="step-number">3</div>
              <h3>Desenvolvimento</h3>
              <p>Você acompanha o desenvolvimento e valida as funcionalidades comigo.</p>
            </div>
            <div className="process-step" data-reveal>
              <div className="step-number">4</div>
              <h3>Entrega</h3>
              <p>Testamos os fluxos e colocamos a aplicação no ar com a documentação para uso.</p>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Services;
